export const setValueAtPath = function setDeepPropValue(data) {
  /**
   * path = 'path.to.prop'
   */
  const { object, path, value, defaultValue } = data;

  if (!object || !path) {
    return;
  }

  const keyPath = path.split('.');

  if (keyPath.length === 0) {
    return;
  }

  if (keyPath.length === 1) {
    const key = keyPath[0];
    object[key] = value || defaultValue;

    return;
  }

  const currentKey = keyPath.shift();

  return setValueAtPath({
    object: object[currentKey],
    path: keyPath.join('.'),
    value,
    defaultValue,
  });
};

export const getValueAtPath = function getDeepPropValue(data) {
  /**
   * path = 'path.to.prop'
   */
  const { object, path } = data;

  if (!object || !path) {
    return;
  }

  const keyPath = path.split('.');

  if (keyPath.length === 0) {
    return;
  }

  if (keyPath.length === 1) {
    const key = keyPath[0];

    return object[key];
  }

  const currentKey = keyPath.shift();

  return getValueAtPath({
    object: object[currentKey],
    path: keyPath.join('.'),
  });
};
